<template>
    <div>
        <div class="row">
            <div :class="['col_12', {'loading_overlay': loading}]">
                <div class="card no_border">
                    <div class="card-header">
                        <div class="d_flex_btwn form_action_btn width_full">
                            <div class="card-title">{{ title }}</div>
                            <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.back') }}</router-link>
                        </div>
                    </div>
                    <div class="card-body pl_0 pr_0">
                        <div class="row">
                            <div class="col_4">
                                <div :class="['form-group', {'has_error': errorFor('title')}]">
                                    <label>{{ $t('sidebar.fileDownload.title') }}</label>
                                    <input type="text" class="form_global" v-model="form.title">
                                    <v-errors :errors="errorFor('title')" />
                                </div>
                            </div>
                            <div class="col_4">
                                <div :class="['form-group', {'has_error': errorFor('grade')}]">
                                    <label>{{ $t('sidebar.fileDownload.grade') }}</label>
                                    <select class="form_global" v-model="form.grade">
                                        <option value="">학년 선택</option>
                                        <option v-for="grade in grades" :key="grade.id" :value="grade.id">{{ grade.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('grade')" />
                                </div>
                            </div>
                            <div class="col_4">
                                <div :class="['form-group', {'has_error': errorFor('semester')}]">
                                    <label>{{ $t('sidebar.fileDownload.semester') }}</label>
                                    <select class="form_global" v-model="form.semester">
                                        <option value="">학기 선택</option>
                                        <option v-for="semester in semesters" :key="semester.id" :value="semester.id">{{ semester.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('semester')" />
                                </div>
                            </div>
                            <div class="col_4">
                                <div class="form-group ">
                                    <label>{{ $t('sidebar.fileDownload.file') }}</label>
                                    <input type="file" class="form_global" ref="download_file" @input="onFileChange($event)">
                                    <v-errors :errors="errorFor('file')"></v-errors>
                                </div>
                            </div>
                        </div>

                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                            <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
        baseUrl: process.env.VUE_APP_BASE,
        title: this.$t('sidebar.fileDownload.addFile'),
        cancelRouteName: 'download_list',
        form: {
            title: '',
            file: '',
            grade: '',
            semester: '',
        },
        grades: [],
        semesters: [],
    }
  },
  mounted() {
      this.getGradeList()
      this.getSemesterList()
    if (this.$route.name === 'download_edit') {
      this.axios.get('/file-downloads/'+this.$route.params.id)
        .then(({data}) => {
            let dlData = data.data;
            this.form.title = dlData.title
            this.form.grade = dlData.grade_id
            this.form.semester = dlData.semester_id
            this.form.file = dlData.file
        })
      this.title = this.$t('sidebar.fileDownload.editFile');
    }
  },
  methods: {
      getGradeList(){
          this.axios.get('/grades').then(({data}) => {
              this.grades = data.data
          })
      },
      getSemesterList() {
          this.axios.get('/semesters').then(({data}) => {
              this.semesters = data.data
          })
      },
    onFileChange(e) {
        this.form.file = e.target.files[0]
        // this.tempPhoto = URL.createObjectURL(e.target.files[0]);
    },
    submit() {
        this.allErrors = null;
        this.loading = true;

        let apiUrl;

        let formData = new FormData();

        Object.keys(this.form).forEach(key => {
            formData.append(key, this.form[key] ? this.form[key] : '');
        })

        if (this.$route.name === 'download_edit') {
            apiUrl = '/file-downloads/'+this.$route.params.id
            formData.append('_method','PATCH')
        } else {
            apiUrl = '/file-downloads'
        }

        this.errors = null;

        this.axios.post(apiUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
        .then(({data}) => {
            if (data.success) {
                this.$router.push({name: 'download_list'});
                if (this.$route.name === 'download_edit') {
                    this.showSuccessMsg(this.$t('common.updateSuccess'))
                } else {
                  this.showSuccessMsg(this.$t('common.addSuccess'))
                }
            } else {
                this.show
              this.showFailMsg(data.message)
            }
        })
        .catch((err) => {
            this.allErrors = err.response.data.errors;
        })
        .finally(() => {
            this.loading = false;
        });
    }
  }
}
</script>

<style scoped>

</style>
